import React, { memo } from 'react';
import { useTranslation, withTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import compose from 'recompose/compose';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';

import { validate } from '../utils/contactUsFormValidation';
import ContactUsFormFields from './ContactUsFormFields';
import {
    maxFileSize,
    maxTotalFilesSize,
    maxNumberOfFiles,
    columnGridCount,
    allowedMimeTypes,
} from '../config/constants';

const ContactUsForm = ({
    handleSubmit,
    onSubmit,
    submitting,
}) => {
    const { t } = useTranslation('PayseraContactFormBundle');

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <ContactUsFormFields
                maxFileSize={maxFileSize}
                maxTotalFilesSize={maxTotalFilesSize}
                maxNumberOfFiles={maxNumberOfFiles}
                columnGridCount={columnGridCount}
                allowedMimeTypes={allowedMimeTypes}
            />
            <Button
                type="submit"
                bsStyle="primary"
                disabled={submitting}
                className="pull-right"
            >
                {t('contact_form.contact.submit')}
            </Button>
        </form>
    );
};

ContactUsForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
};

export default compose(
    withTranslation('validators'),
    reduxForm({
        form: 'contact-us',
        destroyOnUnmount: false,
        validate,
    }),
    memo,
)(ContactUsForm);
